
import Cookies from "universal-cookie";
const cookies = new Cookies();

export const ajax_config_file = {
  headers: {
    Authorization: `Bearer ${cookies.get("auth_key")}`, // ✅ Bearer token
    email: cookies.get("email"),                        // ✅ custom header
    authenticated: cookies.get("authenticated"),        // ✅ custom header
    Accept: "application/json"                          // ✅ expect JSON
    // 🚫 DO NOT set Content-Type here
    // 🚫 DO NOT set Access-Control-Allow-Origin here
  }
};
